import { Component, Input, ViewEncapsulation, HostListener, OnInit, OnDestroy } from '@angular/core';
import { environment } from '../../../environments/environment';
import { EmitterService } from '../../services/emitter.service';
import { Utility } from '../../shared/utility/utility';
import { CountryDataService } from '../../services/country.service';
import { Router } from '@angular/router';
import { AppDetailsService } from '../../services/app-details.services';
import { UserDetailsService } from '../../services/user-details.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { GamingUtility } from '../../gaming/gaming.utility';
import { AjaxService } from '../../services/ajax.service';
import { GameWindowService } from '../../services/gameWindow.services';

@Component({
  selector: 'app-lobby-game-card',
  templateUrl: './lobby-game-card.component.html',
  styleUrls: ['./lobby-game-card.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LobbyGameCardComponent implements OnInit, OnDestroy {
  
  @Input() game;
  @Input() liveGameDetails;
  @Input() skelton_loaders = false;
  @Input() isFavourite;
  siteUrlPath: string = environment.siteUrl;
  gameUrlPath: string = environment.gamePath;
  mediaPath = environment.mediaPath;
  userLogin;
  isDemoGamesExempted: boolean = false;
  langCode: string;
  destroy$: Subject<boolean> = new Subject();
  windowType: string;
  isUserLoggedIn;
  imageLoadedError = true;
  
  featuredTagGames;
  priorityTag;

  @HostListener('window:resize') onResize() {
    this.resizeWindow();  
  }
  constructor(
    private emitter: EmitterService,
    private utils: Utility,
    private countryDataService: CountryDataService,
    private router: Router,
    private appDetails: AppDetailsService,
    public userService: UserDetailsService,
    private gamingUtils: GamingUtility,
    private ajaxService: AjaxService,
    private gameWindowService:GameWindowService

  ) {
    this.emitter.loadHomeBanner$.pipe(takeUntil(this.destroy$)).subscribe(
      () => {
        this.userLogin = this.utils.isUserLoggedIn();
      }
    );
    this.langCode = localStorage.getItem('langCode')
    this.emitter.langCodeSource$.pipe(takeUntil(this.destroy$)).subscribe(langCode => {
      this.langCode = langCode;
    });
    this.emitter.updateLoginStatus$.pipe(takeUntil(this.destroy$)).subscribe(loginStatus => {
      this.isUserLoggedIn = loginStatus
    });
  }  

  resizeWindow() {
    this.windowType = document.body.clientWidth <= 992 ? 'mobile' : 'desktop';
  }

  handleImageError(event: any) {
    this.imageLoadedError = true;
  }
  
  ngOnInit() {
    // this.featuredTagGames = this.game && this.game['tagList'] && this.game['tagList'].join('').includes('featured')
    this.featuredTagGames = this.game &&
                                  Array.isArray(this.game.tagList) &&
                                  this.game.tagList.some(
                                    tag => tag === 'featured' || tag.startsWith('custom')
                                  );
  this.priorityTag = this.game?.tagList?.includes('featured')
                                    ? 'featured'
                                    : this.game?.tagList?.find(tag => tag.startsWith('custom')) ?? null;
    this.isUserLoggedIn = this.utils.isUserLoggedIn();
    this.resizeWindow();
    this.userLogin = this.utils.isUserLoggedIn();
    this.emitter.updateLoginStatus$.pipe(takeUntil(this.destroy$)).subscribe(status => {
      this.userLogin = status;
    });
    if(!this.utils.isUserLoggedIn()){
      this.isDemoGamesExempted = environment.demoGamesExemptedCountries.indexOf(this.countryDataService.ipCountry) >= 0 ? true : false;
    }
  }

  gameLauncher(gameType,game): void {
    this.utils.gameLauncher(gameType,game,this.userService, this.gamingUtils);
  }

  setFavouriteGames(gameId) {
    this.utils.setFavouriteGames(gameId, this.isFavourite);
  }

  ngOnDestroy(){
    this.destroy$.next(true)
    this.destroy$.complete()
  }

  imageLoaded(){
    this.imageLoadedError = false;
  }
}
